export default function SvgSettings() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
    >
      <path
        d="M3.61087 4.88209C3.69487 4.90317 3.77173 4.94673 3.833 5.00793L10.6766 11.8517L11.915 10.6134L5.07122 3.7697C5.00984 3.70838 4.96646 3.63127 4.94526 3.54703L4.51454 1.83003L1.65922 0.197632L0.260986 1.5958L1.89387 4.45309L3.61087 4.88209Z"
        fill="url(#paint0_linear_373_1374)"
      />
      <path
        d="M9.69682 20.4928L20.5566 9.6329C20.6755 9.51382 20.8481 9.46608 21.0113 9.50669C22.4411 9.87315 23.9598 9.5556 25.1235 8.6477C26.2874 7.73974 26.9644 6.34347 26.9566 4.86752C26.9566 4.77762 26.954 4.68706 26.9481 4.59569L24.4223 7.12124C24.2943 7.24935 24.1045 7.29426 23.9324 7.23687L21.0596 6.27914C20.9166 6.23177 20.8044 6.11957 20.7566 5.97665L19.7991 3.10376C19.7417 2.93196 19.7865 2.74209 19.9148 2.61386L22.4406 0.0881258C20.9196 -0.0064986 19.445 0.632523 18.4735 1.8066C17.5021 2.98093 17.1511 4.54911 17.5289 6.02531C17.5698 6.18876 17.5221 6.36129 17.4031 6.48031L6.54349 17.3395C6.42435 17.4577 6.25194 17.5056 6.08862 17.4656C5.71055 17.3685 5.32173 17.3182 4.93119 17.3166C2.86905 17.3031 1.02652 18.603 0.347561 20.5506C-0.331031 22.4981 0.304488 24.6617 1.92859 25.9327C3.55269 27.2038 5.80561 27.301 7.53293 26.1741C9.26038 25.0473 10.0794 22.9464 9.57036 20.9476C9.52987 20.7844 9.57774 20.6116 9.69682 20.4928ZM6.09667 24.0201H3.76608L2.61664 22.1049L3.76608 20.1895H6.09667L7.24586 22.1049L6.09667 24.0201ZM7.94455 18.4146L18.4783 7.88069L19.1553 8.55774L8.62148 19.0917L7.94455 18.4146Z"
        fill="url(#paint1_linear_373_1374)"
      />
      <path
        d="M23.03 26.7073C24.0965 27.1083 25.2989 26.8483 26.1046 26.0426C26.9104 25.2367 27.1705 24.0341 26.7694 22.9679L23.03 26.7073Z"
        fill="url(#paint2_linear_373_1374)"
      />
      <path
        d="M26.1051 21.9307L20.7273 16.5508C20.1341 17.0494 19.2582 17.0115 18.7099 16.4639C18.1616 15.9164 18.1229 15.0407 18.6207 14.4469L17.8591 13.6844L13.748 17.7956L14.5143 18.5618C15.1074 18.0632 15.9835 18.1009 16.5315 18.6484C17.0797 19.196 17.1186 20.0718 16.6208 20.6656L21.9941 26.0417C22.0527 26.1003 22.1146 26.1547 22.1771 26.2075L26.271 22.1135C26.2183 22.0509 26.1637 21.9893 26.1051 21.9307ZM23.2663 23.8797L18.4782 19.0917L19.1552 18.4146L23.9433 23.2029L23.2663 23.8797Z"
        fill="url(#paint3_linear_373_1374)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_373_1374"
          x1="0.260986"
          y1="10.8343"
          x2="13.4533"
          y2="7.14457"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_373_1374"
          x1="0.0788575"
          y1="24.6106"
          x2="30.5046"
          y2="16.1011"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_373_1374"
          x1="23.03"
          y1="26.5505"
          x2="27.4734"
          y2="25.3077"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_373_1374"
          x1="13.748"
          y1="25.1142"
          x2="27.9241"
          y2="21.1494"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
